<template>
  <div>
    <v-dialog
      v-model="isVisible"
      fullscreen
      hide-overlay
      persistent
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card v-if="viewData">
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar :color="viewData.NameColor || 'indigo'">
            <v-icon dark>
              {{ $t(`Log.Dialog.View.Toolbar.Icon`) }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              <v-chip
                class="mb-1 px-1 font-weight-bold"
                label
                small
              >
                #{{ viewData.MenuId }}
              </v-chip>

              {{ menuName }}

              <div class="text-caption grey--text">
                {{ viewData.Description }}
              </div>
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pt-5 fill-height">
          <v-simple-table
            dense
            fixed-header
          >
            <template #default>
              <thead>
                <tr>
                  <th
                    class="text-h6 pb-2"
                    colspan="3"
                  >
                    {{ viewData.Description }}
                  </th>
                </tr>
                <tr>
                  <th>{{ $t('Log.Dialog.View.Header.Type') }}</th>
                  <th v-if="viewData.Properties.old">
                    {{ $t('Log.Dialog.View.Header.Old') }}
                  </th>
                  <th>{{ $t('Log.Dialog.View.Header.New') }}</th>
                </tr>
              </thead>
              <tbody v-if="viewData.Properties.new">
                <tr
                  v-for="(value, key) in viewData.Properties.new"
                  :key="`attribute-${key}`"
                >
                  <td>{{ fieldName(key) }}</td>
                  <td v-if="viewData.Properties.old ">
                    <pre v-safe-html="syntaxHighlight(viewData.Properties.old[key])" />
                  </td>
                  <td>
                    <pre v-safe-html="syntaxHighlight(value)" />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <template v-for="(relatedItem, relatedIdx) in viewData.Related">
            <v-simple-table
              :key="`related-${relatedItem.Id}-${relatedIdx}`"
              class="mt-4"
              dense
              fixed-header
            >
              <template #default>
                <thead>
                  <tr>
                    <th
                      class="text-h6 pb-2"
                      colspan="3"
                    >
                      {{ relatedItem.Description }}
                    </th>
                  </tr>
                  <tr>
                    <th>{{ $t('Log.Dialog.View.Header.Type') }}</th>
                    <th v-if="relatedItem.Properties.old">
                      {{ $t('Log.Dialog.View.Header.Old') }}
                    </th>
                    <th>{{ $t('Log.Dialog.View.Header.New') }}</th>
                  </tr>
                </thead>
                <tbody v-if="relatedItem.Properties.new">
                  <tr
                    v-for="(value, key) in relatedItem.Properties.new"
                    :key="`related-${relatedItem.Id}-${relatedIdx}-attribute-${key}`"
                  >
                    <td>{{ fieldName(key) }}</td>
                    <td v-if="relatedItem.Properties.old ">
                      <pre v-safe-html="syntaxHighlight(relatedItem.Properties.old[key])" />
                    </td>
                    <td>
                      <pre v-safe-html="syntaxHighlight(value)" />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogVisible from '@/mixins/dialogVisible'
import Auth from '@/mixins/auth'
import {syntaxHighlight} from '@/lib/helper/helper'

export default {
  name      : 'ActivityLogDialog',
  components: {},
  directives: {},
  mixins    : [Auth, DialogVisible],
  props     : {
    item: {
      type   : Object,
      default: undefined
    },
    menuName: {
      type   : String,
      default: ''
    }
  },
  data() {
    return {
      viewData: null
    }
  },
  computed: {},
  watch   : {
    item(newVal) {
      this.viewData = newVal
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    syntaxHighlight,

    fieldName(field) {
      return this.$te(`Log.Fields.${field}`) ? this.$t(`Log.Fields.${field}`) : field
    },

    logName(logType) {
      return logType
    },
    logColor(logType) {
      return 'grey'
    }
  }
}
</script>

<style scoped>

</style>
